import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import { Oval } from 'react-loader-spinner'
import IllustrationAccess from "../../assets/img/access.png"
import "./VistaAdminNormas.scss"
import "../../pages/NotFound/NotFound.scss"
import CarruselListaConsultoras from '../CarruselListaConsultoras'

function VistaAdminNormas(props) {
    const [loadingConsultoras, setLoadingConsultoras] = useState(true)
    const [loadingEmpresas, setLoadingEmpresas] = useState(false)

    const [error, setError] = useState(null)
    const [errorEmpresa, setErrorEmpresa] = useState(null)

    const [consultoras, setConsultoras] = useState([])
    const [empresas, setEmpresas] = useState([])

    const [idConsult, setIdConsult] = useState(null)

    const [file, setFile] = useState(null)
    const [errors, setErrors] = useState({})
    const [errorFile, setErrorFile] = useState(null)
    const [successMessage, setSuccessMessage] = useState("");

    const fetchConsultoras = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/consultorasView`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user: props.user
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setError(data.codeError)
                setLoadingConsultoras(false)
            } else {
                setConsultoras(data.objeto)
                setLoadingConsultoras(false)  
            }
        } catch (error) {
            setError("Error: Conexión con backend.")
            setLoadingConsultoras(false)
        }
    }

    useEffect(() => {
        fetchConsultoras()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleEmpresasById = async (id) => {
        setIdConsult(id)
        setLoadingEmpresas(true)
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/empresasView`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user: props.user,
                    idConsultora: id
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setErrorEmpresa(data.codeError)
                setLoadingEmpresas(false)
            } else {
                setEmpresas(data.objeto)
                setLoadingEmpresas(false)
            }
        } catch (error) {
            setErrorEmpresa("Error: Conexión con backend.")
            setLoadingEmpresas(false)
        }
    }

    const handleEmpresasSinConsultora = async () => {
        setIdConsult(0)
        setLoadingEmpresas(true)
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/sinEmpresasView`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user: props.user,
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setErrorEmpresa(data.codeError)
                setLoadingEmpresas(false)
            } else {
                setEmpresas(data.objeto)
                setLoadingEmpresas(false)
            }
        } catch (error) {
            setErrorEmpresa("Error: Conexión con backend.")
            setLoadingEmpresas(false)
        }
    }

    // SUBIR EXCEL
    const handleChangeFile = (e) => {
        setFile(e.target.files[0]);
    }

    const handleSubirExcel = async (e) => {
        e.preventDefault()

        let newErrors = {}
        setSuccessMessage("")

        if (!file) {
            newErrors.file = "Agregue un archivo válido."
        }

        if((Object.keys(newErrors).length === 0)){
            const formData = new FormData()
            formData.append('file', file)
            formData.append('user', JSON.stringify(props.user))
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/addNormativa`, {
                    method: "POST",
                    body: formData
                })
                const data = await res.json()
                if(data.error !== 0){
                    setErrorFile(data.errorDetalle || data.codeError)
                } else {
                    setSuccessMessage("Archivo subido correctamente.");
                    setErrors({})
                    setErrorFile(null)
                    setFile(null)
                }
            } catch (error) {
                setErrorFile("Error: Conexión con backend.")
            }
        } else {
            setErrors(newErrors)
        }

    }

    return (
        <div className='normas__dashboards'>
            <div className='d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-2 mb-4'>
                {/* subir excel de normas */}
                <h4 className='m-0'>Subir excel:</h4>
                <input 
                    className='inputFile form-control rounded-pill' 
                    type='file' 
                    onChange={handleChangeFile} 
                />
                <button 
                    onClick={handleSubirExcel} 
                    className='btn btn-primary rounded-pill fw-medium px-3 cursor-pointer'
                >
                    + agregar archivo
                </button>
                {/* Mensajes de error y éxito */}
                {errors.file && (
                    <span className='normas--textError text-danger d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.file}</span>
                )}
                {errorFile !== null && (
                    <span className='normas--textError text-danger d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errorFile}</span>
                )}
                {successMessage && (
                    <span className='text-success fw-semibold'>{successMessage}</span>
                )}
                {/* botón para editar texto de las normas */}
                <Link to="/normas/editar-normas" className='btnEditNorma btn btn-success rounded-circle fw-medium cursor-pointer ms-auto d-flex align-items-center justify-content-center'><i className="bi bi-pencil"></i></Link>
            </div>
            {/* lista de consultoras */}
            <div className='normas__dashboards__container scroll--y'>
                {loadingConsultoras ? (
                    <div className='loading__normas d-flex flex-column align-items-center justify-content-center'>
                        <Oval
                            visible={true}
                            height="80"
                            width="80"
                            color="#0d6efd"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                        <p className='fw-medium'>Loading...</p>
                    </div>
                ) : (
                    <>
                        {error ? (
                            <div className='not__found d-flex flex-column align-items-center justify-content-center'>
                                <img className='mb-4' src={IllustrationAccess} alt="" />
                                <h2 className='text-danger fw-semibold mb-2'>Oops!</h2>
                                <p className='text-center'>{error}</p>
                                <Link className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' to={"/inicio"}>Regresar al home</Link>
                            </div>
                        ) : (
                            <>
                                {consultoras.length === 0 ? (
                                    <div className='not__found d-flex flex-column align-items-center justify-content-center'>
                                        <img className='mb-4' src={IllustrationAccess} alt="" />
                                        <h2 className='fw-semibold mb-2'>No tiene consultoras asignadas.</h2>
                                        <p className='text-center'>Contactar al equipo de soporte para el manejo de áreas.</p>
                                        <Link className='btn shadow-sm fw-medium px-3' to={"/inicio"}>Regresar al home</Link>
                                    </div>
                                ) : (
                                    <div className='normas__consultoras mb-4'>
                                        <CarruselListaConsultoras items={consultoras} fn={handleEmpresasById}/>
                                        <div onClick={handleEmpresasSinConsultora} className='normas__consultoras__consultora border border-light-subtle shadow-sm rounded-3 d-flex flex-row align-items-center'>
                                            <h4 className='p-0 m-0 text-start'>Sin consultoras asociadas</h4>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
                {/* LISTADO DE EMPRESAS */}
                {loadingEmpresas ? (
                    <div className='loading__home d-flex flex-column align-items-center justify-content-center'>
                        <Oval
                            visible={true}
                            height="80"
                            width="80"
                            color="#0d6efd"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                        <p className='fw-medium'>Loading...</p>
                    </div>
                ) : (
                    <>
                        {errorEmpresa ? (
                            <div className='not__found d-flex flex-column align-items-center justify-content-center'>
                                <img className='mb-4' src={IllustrationAccess} alt="" />
                                <h2 className='fw-semibold mb-2'>Oops!</h2>
                                <p className='text-center'>{errorEmpresa}</p>
                                <Link className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' to={"/inicio"}>Regresar al home</Link>
                            </div>
                        ) : (
                        <>
                            {empresas.length === 0 ? (
                                <div className='invisible'></div>
                            ) : (
                                <div className='table__custom'>
                                    <div className='table__custom__header'>
                                        <div className='table__custom__cell table__custom__cell--title fw-bold cell__id text-center'></div>
                                        <div className='table__custom__cell table__custom__cell--title fw-bold cell__name'>Nombre</div>
                                    </div>
                                    <div className='table__custom__body'>
                                        {empresas.map((e, i) => {
                                        return <Link 
                                            key={i} 
                                            className='table__custom__row text-decoration-none text-dark' 
                                            to={`/normas/consultora/${idConsult}/empresa/${e.id_empresa}`} 
                                        >
                                            <div className='table__custom__cell cell__id fw-bold text-center'>{e.id_empresa}</div>
                                            <div className='table__custom__cell cell__name'>{e.nombre}</div>
                                        </Link>
                                        })}
                                    </div>
                                </div>
                            )}
                        </>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default VistaAdminNormas